import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import LoginComponent from "../components/pages/onboarding/login/LoginPageComponent";
import { connect } from "react-redux";
import { CssBaseline, createMuiTheme, ThemeProvider } from "@material-ui/core";
import Checkout from "../components/pages/main/checkout/checkout.component";
import OnBoardingLayout from "../components/pages/onboarding/onboarding-layout/OnBoardingLayout";
import AddCompanyComponent from "../components/pages/onboarding/company/AddCompanyComponent";
import ProductCategory from "../components/pages/main/product-category/ProductCategory";
import ProtectedRoute from "../router/ProtectedRoute";
import MainLayoutComponent from "../components/pages/main/main-layout/MainLayoutComponent";
import LoadingOverlay from "react-loading-overlay";
import "bootstrap/dist/css/bootstrap.min.css";
// import InventoryList from "../components/pages/inventories/inventory-list/InventoryList";
import {
  MainProtectedRoute,
  MainSalesProtectedRoute,
} from "../router/MainProtectedRoute";
import Employees from "../components/pages/main/employee/Employees";
import Product from "../components/pages/main/product/Product";
import Location, {
  Locations,
} from "../components/pages/main/location/Location";
import PickUpStation from "../components/pages/main/pickupstation/PickUpStation";
import OrderDelivery from "../components/pages/main/order-delivery/OrderDelivery";
import Dashboard from "../components/pages/main/dashboard/dashboard";
import Inventory from "../components/pages/main/inventory/Inventory";
import { IncomingInventory } from "../components/pages/main/inventory/IncomingInventory";
import OutgoingInventory from "../components/pages/main/inventory/OutgoingInventory";
import InventoryCount from "../components/pages/main/inventory/InventoryCount";
import WareHouseTransfer from "../components/pages/main/inventory/WareHouseTransfer";
import Sales from "../components/pages/main/sales/Sales";
import NewOrder from "../components/pages/main/sales/orders/NewOrder";
// import Orders from "../components/pages/main/sales/orders/Order";
import Payment from "../components/pages/main/payment/Payment";
import Account from "../components/pages/main/account/Accounts";
import InventoryValuation from "../components/pages/main/inventory/InventoryValuation";
// import InventoryList from "../components/pages/main/inventories/InventoryList";
import SalesReport from "../components/pages/main/inventories/SalesReport";
import ProfitabilityReport from "../components/pages/main/inventory/ProfitabilityReport";
import InventoryManager from "../components/pages/main/dashboard/InventoryManager";
import SalesExecutive from "../components/pages/main/dashboard/SalesExecutive";
import Admin from "../components/pages/main/dashboard/Admin";
import NewMainLayOut from "./NewMainLayOut";
import "./loader";
import Dummy from "../components/pages/main/checkout/dummy";
import AllocateLocation from "../components/pages/main/employee/AllocateLocation";
import Refunds from "../components/pages/main/inventories/refunds/Refunds";
import CompanyCredit from "../components/pages/onboarding/company/CompanyCredit";
import CreditPayment from "../components/pages/main/payment/CreditPayment";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#333996",
      light: "#3c44b126",
    },
    secondary: {
      main: "#f83245",
      light: "#f8324526",
    },
    background: {
      default: "#f4f5fd",
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        transform: "translateZ(0)",
      },
    },
  },
  props: {
    MuiIconButton: {
      disableRipple: true,
    },
  },
});

class App extends React.Component {
  state = { selectedItem: "Tickets" };
  isAuthenticated = false;
  isHaveCompany = true;
  constructor(props) {
    super();

    if (props.is_authenticated) {
      this.isAuthenticated = true;
    }

    if (props.is_have_cac) {
      this.isHaveCompany = true;
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => this.forceUpdate();

  render() {
    return (
      // <ThemeProvider theme={theme}>
      <ThemeProvider>
        <Router>
          <Switch>
            <Route
              exact
              path="/"
              render={() =>
                this.isAuthenticated ? (
                  <Redirect to="/user/login" />
                ) : (
                  <LoginComponent />
                )
              }
            />
            <Route path="/user" component={OnBoardingLayout} />
            <ProtectedRoute
              isAuthenticated={this.isAuthenticated}
              path="/add-company"
              component={AddCompanyComponent}
              exact
            />
            <ProtectedRoute
              isAuthenticated={this.isAuthenticated}
              path="/company-credit"
              component={CompanyCredit}
              exact
            />

            <LoadingOverlay
              active={this.props.spinner}
              className="overlay-height"
              spinner
            >
              <NewMainLayOut
                isAuthenticated={this.isAuthenticated}
                isHaveCompany={this.isHaveCompany}
                path="/home"
                exact
                component={Dashboard}
              />
            </LoadingOverlay>
          </Switch>
        </Router>
        <CssBaseline />
      </ThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    cacNumber: state.userReducer.cacNumber,
    user: state.userReducer.user,
    buttonloader: state.utilityReducer.buttonloader,
    is_authenticated: state.userReducer.is_authenticated,
    is_have_cac: state.userReducer.is_have_cac,
    spinner: state.utilityReducer.spinner,
  };
}
const mapDispatchToProps = (dispatch) => ({
  SetLoader() {
    dispatch({ type: "LOADING_BUTTON_SPINNER" });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
